// extracted by mini-css-extract-plugin
export var MediaGallery_MainSlider = "MainSlider-module--MediaGallery_MainSlider--604fd";
export var desc = "MainSlider-module--desc--05df7";
export var descText = "MainSlider-module--descText--31d8c";
export var mainSlider = "MainSlider-module--mainSlider--438c3";
export var pageNum = "MainSlider-module--pageNum--fa7cb";
export var swiperPaginationCustom = "MainSlider-module--swiper-pagination-custom--64b17";